<template>
  <div>
    <!-- 搜索栏 -->
    <div class="accountset1 searchHeight">
      <div class="backList" @click="goNumList">
        <i class="el-icon-arrow-left"></i>
        <span class="verticalLine">|</span>
        <span class="membership">入会会员</span>
      </div>
      <div>
        <span class="nameCard">会员卡名称：</span>
        <span v-if="!modifyTrue" style="color: #333333">{{ inputN }}</span
        >&nbsp;
        <span v-if="!modifyTrue">
          <el-button
            type="text"
            style="color: #1f4287; font-size: 14px; opacity: 1"
            @click="modify"
            >修改</el-button
          >
        </span>
        <span style="display: inline-block">
          <el-input
            v-if="modifyTrue"
            style="width: 300px; margin-right: 12px"
            placeholder="输入短信内容"
            :maxlength="10"
            v-model="inputN"
          ></el-input>
        </span>
        <span v-if="modifyTrue">
          <el-button type="primary" @click="preSeting">保存设置</el-button>
        </span>
      </div>
      <!-- 下部分切换栏 -->
      <el-tabs v-model="topSelect" @tab-click="tabChage">
        <el-tab-pane :label="messageNumOne" name="1"></el-tab-pane>
        <el-tab-pane :label="messageNumTwo" name="2"></el-tab-pane>
        <el-tab-pane :label="messageNumThree" name="3"></el-tab-pane>
      </el-tabs>
      <!-- <div class="hugStyle">
        <div
          style="display: inline-block;margin-right:40px;"
          :style="{ color: topSelect === 1 ? changeColor : '' }"
          @click="hugItemBtn(1)"
        >
          {{ messageNumOne }}
          <div
            class="underlinedFor"
            :style="{ background: topSelect === 1 ? changeColor : '' ,border: topSelect == 1 ? '1px solid #1F4287' : '1px solid #fff'}"
            style="margin-left:24px;"
          ></div>
        </div>
        <div
          style="display: inline-block;margin-right:40px;"
          :style="{ color: topSelect === 2 ? changeColor : '' }"
          @click="hugItemBtn(2)"
        >
          {{ messageNumTwo }}
          <div
            class="underlinedFor"
            :style="{ background: topSelect === 2 ? changeColor : '' ,border: topSelect == 2 ? '1px solid #1F4287' : '1px solid #fff'}"
            style="margin-left:9px;"
          ></div>
        </div>
        <div
          style="display: inline-block;"
          :style="{ color: topSelect === 3 ? changeColor : '' }"
          @click="hugItemBtn(3)"
        >
          {{ messageNumThree }}
          <div
            class="underlinedFor"
            :style="{ background: topSelect === 3 ? changeColor : '' ,border: topSelect == 3 ? '1px solid #1F4287' : '1px solid #fff'}"
            style="margin-left:9px;"
          ></div>
        </div>
      </div> -->
      <!-- <div class="lineHug"></div> -->
      <!-- 等级卡片布局 会员等级设置 -->
      <div v-if="topSelect == 1">
        <div
          class="display-frame"
          v-for="(item, index) in postData"
          :key="index"
        >
          <!-- 重新布局 -->
          <div class="levelSettingOne">
            <span class="iconVip">
              <span class="spanbox">
                <i
                  class="iconfont iconhuiyuan"
                  style="color: #7489b5; font-size: 19px"
                ></i>
              </span>
              &nbsp;
              <span v-if="!item.edit" style="color: #333333; font-size: 16px">{{
                item.gradeName
              }}</span
              >&nbsp;
              <el-input
                v-if="item.edit"
                style="width: 69px"
                v-model="item.inputNum"
                maxlength="5"
              />
            </span>

            <div class="upgradeLevelSettingsOne" style="margin-left: 162px">
              升级条件设置：
            </div>
            <div class="upgradeLevelSettingsTwo" style="margin-left: 128px">
              累计交易金额≥￥{{
                item.upgradeMinMoney
              }}&nbsp;&nbsp;或者&nbsp;&nbsp; 累计交易次数≥￥{{
                item.upgradeMinCount
              }}
            </div>
            <span style="color: #333333; font-size: 16px; float: right">
              <el-button
                v-if="!item.edit"
                @click="
                  item.edit
                    ? (item.edit = false)
                    : handleEdit(
                        item,
                        item.scoresMemberGradeId,
                        index,
                        item.scoresCardId
                      )
                "
                type="text"
                style="
                  color: #1f4287;
                  font-size: 14px;
                  opacity: 1;
                  font-weight: 400;
                "
                >编辑&nbsp;<i
                  :class="`el-icon-arrow-${item.edit ? 'up' : 'down'}`"
                ></i
              ></el-button>
            </span>
            <span style="color: #333333; font-size: 16px; float: right">
              <el-switch
                v-model="item.isValid"
                :active-value="1"
                :inactive-value="0"
                @change="openSwitch(item, item.scoresMemberGradeId, index)"
              >
              </el-switch
              >&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </div>
          <!-- 点击的时候显示 -->
          <div v-if="item.edit && index === sortIndex">
            <span class="foldStyle">
              <div>
                <span>属性：</span>
                <el-checkbox
                  v-model="checked"
                  @change="checkMoney"
                  style="margin-right: 20px"
                  >交易金额</el-checkbox
                >
                <el-checkbox v-model="checked1" @change="checkNum"
                  >交易次数</el-checkbox
                >
              </div>
              <div>
                <span
                  >交易金额累计达到：<el-input
                    type="number"
                    onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
                    style="width: 146px"
                    v-model="inputMoney"
                    :disabled="disMoney"
                  >
                    <i
                      slot="suffix"
                      style="font-style: normal; margin-right: 10px"
                      >元</i
                    >
                  </el-input></span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>
                  交易次数累计达到&nbsp;
                  <el-input
                    type="number"
                    onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
                    style="width: 146px"
                    v-model="inputNum"
                    :disabled="disNum"
                  >
                    <i
                      slot="suffix"
                      style="font-style: normal; margin-right: 10px"
                      >次</i
                    >
                  </el-input>
                </span>
                <span style="float: right">
                  <el-button @click="item.edit = showHideJudgment = false"
                    >取 消</el-button
                  >
                  <el-button type="primary" @click="sure(item)">保存</el-button>
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
      <!-- 关联店铺 -->
      <div v-if="topSelect == 2" style="margin-top: 26px">
        <div>
          <el-button type="primary" @click="addAssociations">
            添加关联</el-button
          >
          <el-button class="buttonColor" @click="setMainStore"
            ><i style="font-size: 12px"></i> 设置主店铺</el-button
          >
        </div>
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="bindDta"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
            style="width: 100%; border: 1px solid #efefef"
            :cell-style="{ 'text-align': 'left' }"
          >
            <template slot="empty">
              <div style="margin: 20px">
                <img
                  src="../../../assets/images/nodata.png"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;
                  "
                />
                <span style="color: #999999" class="nodata">没有数据哦~</span>
                <!-- <span class="nodata1">暂无数据</span> -->
              </div>
            </template>
            <el-table-column prop="" label="" width="100"></el-table-column>
            <el-table-column prop="platform" label="平台">
              <template slot-scope="scope">
                <span>{{
                  scope.row.platform == "1"
                    ? "淘宝"
                    : scope.row.platform == "2"
                    ? "京东"
                    : scope.row.platform == "3"
                    ? "有赞"
                    : scope.row.platform == "4"
                    ? "微信"
                    : scope.row.platform == "5"
                    ? "抖音"
                    : scope.row.platform == "6"
                    ? "快手"
                    : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="shopTitle"
              label="店铺名称"
            ></el-table-column>
            <el-table-column prop="totalMember" label="会员卡状态">
              <template slot-scope="scope">
                <span>{{ scope.row.bindStatus == 0 ? "已解除" : "正常" }}</span
                >&nbsp;
                <el-button type="text" @click="information(scope.row.shopId)">
                  <i
                    class="iconfont iconbangzhu"
                    style="color: #7489b5; font-size: 16px"
                  ></i>
                  详情</el-button
                >
              </template>
            </el-table-column>
            <el-table-column prop="buyTotalMoney" label="操作">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.bindStatus == 0"
                  type="text"
                  @click="openOne(scope.row.shopId)"
                  >重新关联</el-button
                >
                <el-button
                  v-if="scope.row.bindStatus == 1"
                  type="text"
                  @click="open(scope.row.shopId)"
                  >解除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination background style="float:right;top: 10px;position: relative;"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[10, 20, 30, 50 , 100 ,500]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalList"
                       :current-page="pageNum"></el-pagination> -->
        </div>
      </div>
      <!-- 权益设置 -->
      <div v-if="topSelect == 3" style="margin-top: 26px">
        <div>
          <span>积分名称：</span>
          <span style="display: inline-block">
            <el-input
              placeholder="输入名称"
              style="width: 300px"
              v-model="addRuleParm.ruleName"
              :disabled="isEdit"
              maxlength="5"
              show-word-limit
            ></el-input> </span
          >&nbsp;&nbsp;
        </div>
        <div class="titleTuleset">
          <span class="colorTitle"></span>&nbsp;
          <span>交易积分规则</span>
        </div>
        <div class="tab-cntan">
          <div>
            <span class="label left-distance">基础积分：</span>
            <div class="form-item">
              每消费
              <el-input
                style="width: 100px; margin: 0 5px"
                :disabled="isEdit"
                v-model="addRuleParm.baseScores"
                @change="zhNum"
                onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
                type="number"
              >
                <i
                  slot="suffix"
                  style="font-style: normal; margin-right: 10px; color: #333333"
                  >元</i
                > </el-input
              >获得1积分(线上电商平台确认收货后送积分)
              <el-checkbox
                v-model="addRuleParm.isFreight"
                :disabled="isEdit"
                :true-label="1"
                :false-label="0"
                style="margin-left: 15px"
                >排除运费</el-checkbox
              >
            </div>
          </div>
          <div style="margin-bottom: 22px">
            <span class="label left-distance1">等级积分倍数：</span>
            <div class="form-item item-inline" style="width: 600px">
              <div
                v-for="(item, ind) in addRuleParm.gradeItemParamDTOList"
                :key="ind"
              >
                {{ item.name }}
                <el-input
                  style="width: 136px; margin-left: 5px"
                  :disabled="item.name === 'VIP1' || isEdit"
                  v-model="item.value"
                  onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
                  type="number"
                  @change="gradetimes(item.value, ind)"
                >
                  <i
                    slot="suffix"
                    style="
                      font-style: normal;
                      margin-right: 10px;
                      color: #333333;
                    "
                    >倍积分</i
                  >
                </el-input>
              </div>
            </div>
          </div>
          <div>
            <span class="label left-distance2">不参与店铺商品：</span>
            <div class="form-item" style="height: auto">
              <el-button class="buttonColor" @click="addShop" :disabled="isEdit"
                >添加</el-button
              >
              <div style="margin-top: 10px">
                <el-table
                  :data="addRuleParm.excludeShops"
                  v-if="addRuleParm.excludeShops.length > 0"
                  tooltip-effect="dark"
                  :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
                  style="width: 100%; border: 1px solid #efefef"
                  :cell-style="{ 'text-align': 'left' }"
                >
                  <template slot="empty">
                    <div style="margin: 20px">
                      <img
                        src="../../../assets/images/nodata.png"
                        style="
                          display: inline-block;
                          vertical-align: middle;
                          cursor: pointer;
                        "
                      />
                      <span style="color: #999999" class="nodata"
                        >没有数据哦~</span
                      >
                      <!-- <span class="nodata1">暂无数据</span> -->
                    </div>
                  </template>
                  <el-table-column
                    prop="sellerNick"
                    label="店铺"
                    width="200px"
                  ></el-table-column>
                  <el-table-column label="商品" width="380px">
                    <template slot-scope="scope">
                      <div>
                        <el-radio
                          @change="updateTable"
                          :disabled="isEdit"
                          :label="0"
                          v-model="addRuleParm.excludeShops[scope.$index].type"
                          >全部</el-radio
                        >
                        <el-radio
                          @change="updateTable"
                          :disabled="isEdit"
                          :label="1"
                          v-model="addRuleParm.excludeShops[scope.$index].type"
                          >指定商品</el-radio
                        >
                        <el-button
                          @click="goodsDialog(scope.row)"
                          :disabled="isEdit"
                          v-if="
                            addRuleParm.excludeShops[scope.$index].type === 1 &&
                            scope.row.excludeItems.length === 0
                          "
                          >选择商品</el-button
                        >
                        <el-button
                          @click="goodsDialog(scope.row)"
                          :disabled="isEdit"
                          v-else-if="
                            addRuleParm.excludeShops[scope.$index].type === 1 &&
                            scope.row.excludeItems.length > 0
                          "
                          >已选择({{
                            scope.row.excludeItems.length
                          }})个</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                      <i
                        class="el-icon-delete"
                        style="font-size: 20px; cursor: pointer; color: #b7bcc6"
                        @click="deleteGoods(scope.row)"
                        :disabled="isEdit"
                      ></i>
                      <!-- <el-button
                        type="danger"
                        @click="deleteGoods(scope.row)"
                        :disabled="isEdit"
                        >删除</el-button
                      > -->
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div>
            <span class="label left-distance3"
              >线上店铺积分生效规则：
              <el-radio
                v-model="addRuleParm.scoresEffectiveRules"
                :label="1"
                :disabled="isEdit"
                >订单付款后获得预积分，确认收货后为正式积分</el-radio
              >
              <div style="margin-left: 158px">
                <el-radio
                  v-model="addRuleParm.scoresEffectiveRules"
                  :label="2"
                  :disabled="isEdit"
                  >订单付款后不获得的积分，确认收货后获得正式积分</el-radio
                >
              </div>
            </span>
          </div>
        </div>
        <div class="titleTuleset" style="margin-top: 60px">
          <span class="colorTitle"></span>&nbsp;
          <span>积分过期规则</span>
        </div>
        <div class="tab-cntan">
          <div>
            <span class="label left-distance4">积分有效期：</span>
            <div class="form-item">
              <div style="height: 32px; line-height: 32px">
                <el-radio
                  v-model="addRuleParm.invalidateDateRule"
                  :label="1"
                  :disabled="isEdit"
                  >统一有效期</el-radio
                >
                <el-radio
                  v-model="addRuleParm.invalidateDateRule"
                  :label="2"
                  :disabled="isEdit"
                  >永久有效期</el-radio
                >
              </div>
              <div
                style="margin-top: 5px"
                v-if="addRuleParm.invalidateDateRule === 1"
              >
                <span>自积分发放日起</span>
                <el-select
                  style="width: 95px; margin: 0 5px"
                  v-model="addRuleParm.invalidateDate"
                  :disabled="isEdit"
                >
                  <el-option
                    v-for="(item, index) in yearOption"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option> </el-select
                >的
                <el-select
                  style="width: 90px; margin: 0 5px"
                  v-model="effectiveTime.month"
                  @change="monthChange"
                  :disabled="isEdit"
                >
                  <el-option
                    v-for="(item, index) in monthList"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  >
                  </el-option> </el-select
                >月
                <el-select
                  style="width: 90px; margin: 0 5px"
                  v-model="effectiveTime.day"
                  :disabled="isEdit"
                >
                  <el-option
                    v-for="(item, index) in dayList"
                    :key="index"
                    :label="item.value"
                    :value="item.value"
                  >
                  </el-option> </el-select
                >日前有效
              </div>
            </div>
          </div>
        </div>
        <div class="titleTuleset" style="margin-top: 60px">
          <span class="colorTitle"></span>&nbsp;&nbsp;
          <span>会员日</span>
        </div>
        <div class="tab-cntan">
          <div>
            <span class="label left-distance4">会员日设置：</span>
            <div class="form-item">
              <el-switch
                :disabled="isEdit"
                v-model="addRuleParm.isValid"
                active-value="1"
                inactive-value="0"
                @change="swith"
              >
              </el-switch>
            </div>
          </div>
          <div>
            <span class="label left-distance">参与等级：</span>
            <div class="form-item">
              <el-checkbox-group
                :disabled="disableFalse == 0"
                v-model="addRuleParm.buyerGrade"
              >
                <el-checkbox
                  v-for="(item, index) in checkList"
                  :key="index"
                  :label="item.label"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
          <div>
            <span class="label left-distance5">会员日：</span>
            <div class="form-item">
              每月
              <el-input
                :disabled="disableFalse == 0"
                style="width: 146px; margin: 0 5px"
                v-model="addRuleParm.buyerDay"
                type="number"
              >
                <i
                  slot="suffix"
                  style="font-style: normal; margin-right: 10px; color: #333333"
                  >号</i
                >
              </el-input>
            </div>
          </div>
          <div>
            <span class="label left-distance">奖励设置：</span>
            <div class="form-item">
              订单送积分可获得<el-input
                style="width: 64px; margin: 0 5px"
                :disabled="disableFalse == 0"
                v-model="addRuleParm.scoresMultiple"
                type="number"
              >
                <i
                  slot="suffix"
                  style="font-style: normal; margin-right: 10px; color: #333333"
                  >倍</i
                > </el-input
              >的原积分奖励
            </div>
          </div>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <div v-if="isEdit">
            <el-button
              type="primary"
              size="small"
              @click="isEdit = false"
              style="width: 90px"
              >编辑</el-button
            >
          </div>
          <div v-if="!isEdit">
            <el-button style="width: 90px" @click="cancelOne">取消</el-button>
            <el-button
              type="primary"
              style="width: 90px"
              size="small"
              @click="saveUp"
              >保存</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="lineLengthTwo"></div>
    <!-- 编辑弹框 -->
    <!-- <el-dialog
      title="编辑会员等级规则"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="levelSetting">
        <div class="left-hug">等级名称：</div>
        <el-input
          style="width:200px;"
          v-model="inputMenber"
          maxlength="5"
        ></el-input>
      </div>
      <div class="levelSetting">
        <div class="left-hug">升级设置：</div>
        <div class="border-text">
          <span>属性：</span>
          <el-checkbox v-model="checked" @change="checkMoney"
            >交易金额</el-checkbox
          >
          <el-checkbox v-model="checked1" @change="checkNum"
            >交易次数</el-checkbox
          >
          <div class="line1"></div>
          <div class="annotation" style="margin:8px 0px;">
            交易金额累计达到&nbsp;
            <el-input
              type="number"
              onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
              style="width:100px;"
              v-model="inputMoney"
              :disabled="disMoney"
            ></el-input
            >&nbsp;&nbsp;元
          </div>
          <div class="annotation">
            交易次数累计达到&nbsp;
            <el-input
              type="number"
              onkeypress="return (event.keyCode>=48 && event.keyCode<=57)||event.keyCode==46"
              style="width:100px;"
              v-model="inputNum"
              :disabled="disNum"
            ></el-input
            >&nbsp;&nbsp;次
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:100px;" @click="sure"
          >确定</el-button
        >
        <el-button style="width:100px;" @click="dialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog> -->
    <!-- 添加关联弹框 -->
    <el-dialog
      title="关联店铺"
      :visible.sync="shopStores"
      width="468px"
      :before-close="handleCloseUn"
    >
      <div>
        <el-table
          ref="multipleTable"
          :data="unbindData"
          tooltip-effect="dark"
          class="relation-box"
          :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
          style="width: 100%; border: 1px solid #efefef"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div style="margin: 20px">
              <img
                src="../../../assets/images/nodata.png"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  cursor: pointer;
                "
              />
              <span style="color: #999999" class="nodata">没有数据哦~</span>
              <!-- <span class="nodata1">暂无数据</span> -->
            </div>
          </template>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="" label="" width="30px;"></el-table-column>
          <el-table-column prop="shopTitle" label="店铺"></el-table-column>
          <el-table-column prop="platformName" label="平台"></el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="shopStores = false" style="width: 90px"
          >取消</el-button
        >
        <el-button type="primary" style="width: 90px" @click="preserveSure"
          >确定</el-button
        >
      </span>

      <!-- <el-pagination background style="float:right;top: 10px;position: relative;"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[10, 20, 30, 50 , 100 ,500]"
                       :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="totalList"
                       :current-page="pageNum"></el-pagination> -->
    </el-dialog>
    <!-- 详情弹框 -->
    <el-dialog
      title="详情"
      :visible.sync="details"
      width="643px"
      :before-close="handleCloseDetails"
    >
      <div style="margin-bottom: 10px">
        <Top>
          <template slot="right">
            <div class="slotClass">
              <div style="display: flex; align-items: center">
                <img
                  src="@/assets/images/tishiicon.png"
                  style="
                    display: inline-block;
                    cursor: pointer;
                    margin-right: 8px;
                  "
                />
                <span style="font-size: 13px"
                  >淘宝/京东店铺绑定会员卡功能请先接入会员通，如果店铺未开通会员通请先去申请</span
                >
                <a
                  href="https://open.taobao.com/doc.htm?docId=104329&docType=1&source=search"
                  style="
                    text-decoration: none;
                    margin-left: 10px;
                    color: #1f4287;
                  "
                  >前往申请</a
                >
              </div>
            </div>
          </template>
        </Top>
      </div>
      <div class="slotClassTwo">
        <span>请点击下面授权按钮，进行授权（必须使用该店铺账号授权） </span>
        <div style="margin-top: 12px; text-align: center">
          <el-button
            class="buttonColor"
            style="width: 150px"
            @click="goToAuthorization"
            >前往授权</el-button
          >
        </div>
        <div
          style="
            margin-top: 8px;
            text-align: center;
            color: #ff9f3e;
            font-size: 13px;
          "
        >
          授权成功后，点击确定即可
        </div>
      </div>
      <span slot="footer">
        <el-button @click="details = false">取消</el-button>
        <el-button type="primary" @click="preserveDetails">确定</el-button>
      </span>
    </el-dialog>
    <!-- 添加弹框 -->
    <el-dialog
      title="选择店铺"
      :visible.sync="addDialogVisible"
      width="600px"
      :before-close="handleCloseAdd"
    >
      <div style="padding: 20px 0; height: auto">
        <span
          v-for="(item, index) in shopInfo"
          :key="index"
          class="shopItem"
          :class="{
            active:
              selectshop.map((i) => i.sellerNick).indexOf(item.sellerNick) !=
              -1,
          }"
          @click="selShop(item)"
          >{{ item.sellerNick }}
          <img
            v-if="
              selectshop.map((i) => i.sellerNick).indexOf(item.sellerNick) != -1
            "
            class="right-gou"
            src="@/assets/images/right2.png"
            alt
          />
        </span>
      </div>
      <div style="text-align: right; padding-bottom: 10px">
        <el-button type="primary" @click="preserve1">保存</el-button>
      </div>
    </el-dialog>
    <!-- 设置主页面 -->
    <el-dialog
      title="设置主店铺"
      :visible.sync="setShop"
      width="468px"
      :before-close="setShopClose"
    >
      <div>
        <el-table
          ref="multipleTable"
          :data="setShopData"
          tooltip-effect="dark"
          class="setting-table"
          :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
          style="width: 100%; border: 1px solid #eee"
          @selection-change="handleSelectionChange1"
        >
          <template slot="empty">
            <div style="margin-bottom: 20px">
              <img
                src="../../../assets/images/nodata.png"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  cursor: pointer;
                "
              />
              <span style="color: #999999" class="nodata">没有数据哦~</span>
              <!-- <span class="nodata1">暂无数据</span> -->
            </div>
          </template>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="" label="" width="30px;"></el-table-column>
          <el-table-column prop="shopTitle" label="店铺名称"></el-table-column>
          <el-table-column prop="platform" label="平台">
            <template slot-scope="scope">
              <span>{{
                scope.row.platform == "1"
                  ? "淘宝"
                  : scope.row.platform == "2"
                  ? "京东"
                  : scope.row.platform == "3"
                  ? "有赞"
                  : "未知"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setShop = false" style="width: 90px">取消</el-button>
        <el-button type="primary" style="width: 90px" @click="setShopSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 解除 -->
    <el-dialog title="提示" :visible.sync="sureDialogVisible" width="452px">
      <div class="exprot-btntext">
        <img src="@/assets/images/waring.png" alt />
        <span>是否确认解除绑定</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sureDialogVisible = false" class="width_96"
          >取 消</el-button
        >
        <el-button type="primary" @click="deleteConfirm" class="width_96"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 选择商品组件 -->
    <selectGoodsCard
      v-if="goodsState"
      @transferName="dataBtn"
      :goodsArr="goodsCollection"
      :shopItem="selectCol"
    >
    </selectGoodsCard>
  </div>
</template>
<script>
import { mapState } from "vuex";
import qs from "qs";
// import {getCustomerSellerList} from "../../api/public";//获取品牌店铺
import selectGoodsCard from "@/components/select-goods-card";
import Top from "@/components/top-title";
import {
  rename,
  update,
  getDetailById,
  setValid,
  gradeList,
  getById,
  unbindList,
  bindList,
  relationShop,
  authorize,
  shopUnbind,
  ruleUpdate,
  ruleDetail,
  pageList,
  setMajor,
  rebind,
} from "@/api/manage/scoreList";
// import { delete } from 'vue/types/umd';
export default {
  name: "card_edit",
  filters: {
    // statusStr(status) {
    //   return { 0: "", 1: "VIP1",2: "VIP2",3: "VIP3",4: "VIP4",5: "VIP5",6: "VIP6"}[status];
    // },
  },
  props: {
    pastId: null,
    newData: null,
    formate: null,
    index: null,
  },
  components: {
    selectGoodsCard,
    Top,
  },
  data() {
    return {
      disableFalse: "",
      sureDialogVisible: false,
      shopIds1: "",
      modifyTrue: false,
      sortIndex: 0,
      showHideJudgment: false,
      dis: false, //开关第一个默认
      setShop: false,
      setShopData: [], //设置主店铺数据
      goodsState: false,
      detailsId: "",
      shopIdes: [], //详情
      shopIdes1: [], //设置主店铺选择列表
      unbindData: [],
      bindDta: [],
      upgradeNum: "",
      scoresMemberGradeId: "",
      caId: "",
      disMoney: true,
      disNum: true,
      editData: [],
      postData: [],
      inputMenber: "", //编辑会员名称
      inputMoney: "",
      inputNum: "",
      checked: true, //属性交易金额
      checked1: true, //属性交易次数
      moneyMessage: "",
      timeMessage: "",
      inputN: "", //修改会员卡名称
      isEdit: true,
      showtable: true,
      messageNumOne: "会员等级设置",
      messageNumTwo: "关联店铺",
      messageNumThree: "权益设置",
      topSelect: "1",
      radio: "0",
      dialogVisible: false, //编辑弹窗
      addDialogVisible: false,
      shopStores: false, //关联店铺
      details: false, //详情
      tableData: [
        {
          fileOldName: "京东",
          uploadTime: "林哥",
          totalMember: "最强王者",
        },
        {
          fileOldName: "淘宝",
          uploadTime: "林哥",
          totalMember: "黄金",
        },
      ],
      validateType: 0,
      effectiveTime: {
        month: "",
        day: "",
      },
      yearOption: [],
      monthList: [
        {
          value: "01",
        },
        {
          value: "02",
        },
        {
          value: "03",
        },
        {
          value: "04",
        },
        {
          value: "05",
        },
        {
          value: "06",
        },
        {
          value: "07",
        },
        {
          value: "08",
        },
        {
          value: "09",
        },
        {
          value: "10",
        },
        {
          value: "11",
        },
        {
          value: "12",
        },
      ],
      dayList: [
        {
          value: "01",
        },
        {
          value: "02",
        },
        {
          value: "03",
        },
        {
          value: "04",
        },
        {
          value: "05",
        },
        {
          value: "06",
        },
        {
          value: "07",
        },
        {
          value: "08",
        },
        {
          value: "09",
        },
        {
          value: "10",
        },
        {
          value: "11",
        },
        {
          value: "12",
        },
        {
          value: "13",
        },
        {
          value: "14",
        },
        {
          value: "15",
        },
        {
          value: "16",
        },
        {
          value: "17",
        },
        {
          value: "18",
        },
        {
          value: "19",
        },
        {
          value: "20",
        },
        {
          value: "21",
        },
        {
          value: "22",
        },
        {
          value: "23",
        },
        {
          value: "24",
        },
        {
          value: "25",
        },
        {
          value: "26",
        },
        {
          value: "27",
        },
        {
          value: "28",
        },
        {
          value: "29",
        },
        {
          value: "30",
        },
        {
          value: "31",
        },
      ],
      dayList2: [
        {
          value: "01",
        },
        {
          value: "02",
        },
        {
          value: "03",
        },
        {
          value: "04",
        },
        {
          value: "05",
        },
        {
          value: "06",
        },
        {
          value: "07",
        },
        {
          value: "08",
        },
        {
          value: "09",
        },
        {
          value: "10",
        },
        {
          value: "11",
        },
        {
          value: "12",
        },
        {
          value: "13",
        },
        {
          value: "14",
        },
        {
          value: "15",
        },
        {
          value: "16",
        },
        {
          value: "17",
        },
        {
          value: "18",
        },
        {
          value: "19",
        },
        {
          value: "20",
        },
        {
          value: "21",
        },
        {
          value: "22",
        },
        {
          value: "23",
        },
        {
          value: "24",
        },
        {
          value: "25",
        },
        {
          value: "26",
        },
        {
          value: "27",
        },
        {
          value: "28",
        },
        {
          value: "29",
        },
        {
          value: "30",
        },
        {
          value: "31",
        },
      ],
      checkList: [
        {
          name: "VIP1",
          label: "1",
        },
        {
          name: "VIP2",
          label: "2",
        },
        {
          name: "VIP3",
          label: "3",
        },
        {
          name: "VIP4",
          label: "4",
        },
        {
          name: "VIP5",
          label: "5",
        },
        {
          name: "VIP6",
          label: "7",
        },
      ],
      shopInfo: [], //获取所有店铺会员
      selectshop: [],
      addRuleParm: {
        ruleName: "", //积分名称
        baseScores: "", //基础积分
        isFreight: "1", //排除运费
        scoresEffectiveRules: 1, //线上店铺生效规则
        invalidateDateRule: 1,
        invalidateDate: "", //积分有效期
        isValid: 1, //会员日状态
        buyerGrade: [], //参与等级
        buyerDay: "", //会员日
        scoresMultiple: "", //奖励设置
        excludeShops: [],
        scoresCardRuleId: "",
        vip1: "",
        vip2: "",
        vip3: "",
        vip4: "",
        vip5: "",
        vip6: "",
        gradeItemParamDTOList: [
          {
            name: "VIP1",
            value: "1",
          },
          {
            name: "VIP2",
            value: "",
          },
          {
            name: "VIP3",
            value: "",
          },
          {
            name: "VIP4",
            value: "",
          },
          {
            name: "VIP5",
            value: "",
          },
          {
            name: "VIP6",
            value: "",
          },
        ],
      },
      backId: "", //有ID才编辑
      VIPlen: 0,
      options: [
        {
          value: "1",
          label: "当年",
        },
        {
          value: "2",
          label: "第二年",
        },
        {
          value: "3",
          label: "第三年",
        },
      ],
      goodsCollection: [], //商品选择参数
      selectCol: null,
      cardIdNum: "",
      app: [],
      ruleId: "",
    };
  },
  watch: {
    newData(nVal, oVal) {
      if (nVal) {
        this.cardIdNum = nVal.scoresCardId;
      }
    },
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
      //把city映射给currentCIty
    }),
  },
  created() {
    if (this.$route.query && this.$route.query.pastId) {
      this.pastId = this.$route.query.pastId;
      this.index = this.$route.query.index;
    }
  },
  mounted() {
    for (var i = 0; i < 3; i++) {
      var year = new Date().getFullYear();
      var temp = {
        value: Number(year) + i + "",
      };
      var yearStr = "";
      if (i == "0") {
        yearStr = "当年";
      } else if (i == "1") {
        yearStr = "第二年";
      } else if (i == "2") {
        yearStr = "第三年";
      }
      temp.label = yearStr;
      this.yearOption.push(temp);
    }
    this.gradeList();
    if (this.index == 1) {
      this.getDetailById();
    } else if (this.index == 2) {
      this.inputN = this.newData.cardName;
    }
  },
  methods: {
    //取消
    cancelOne() {
      this.UpdateDetail();
      this.isEdit = true;
    },
    //修改
    modify() {
      this.modifyTrue = true;
    },
    //折叠面板
    handleChange(val) {
      console.log();
    },
    //会员日设置
    swith(val) {
      console.log("1111", val);
      this.disableFalse = String(val);
      if (val == 0) {
        this.addRuleParm.buyerGrade = [];
        this.addRuleParm.buyerDay = "";
        this.addRuleParm.scoresMultiple = "";
      }
    },
    //基础积分只能输入正整数
    zhNum(val) {
      if (!/(^[1-9]\d*$)/.test(val)) {
        this.$message.warning("输入的不是正整数");
        this.addRuleParm.baseScores = "";
        return false;
      } else {
      }
    },
    //操作重新关联
    openOne(type) {
      rebind({
        cardId: this.cardIdNum,
        shopId: type,
      })
        .then((res) => {
          this.$message.success("关联成功");
          this.bindList();
          this.gradeList();
        })
        .catch(() => {});
    },
    //设置主店铺保存
    setShopSure() {
      if (this.shopIdes1.length > 1) {
        this.$message.error("只能设置一个主店铺");
        return;
      }
      setMajor({
        cardId: this.cardIdNum,
        shopId: this.shopIdes1.join(","),
      })
        .then((res) => {
          this.setShop = false;
          this.gradeList();
        })
        .catch(() => {});
    },
    //设置主店铺
    setMainStore() {
      this.setShop = true;
      pageList({
        cardId: this.cardIdNum,
        platform: "1",
      })
        .then((res) => {
          this.setShopData = res.data;
        })
        .catch(() => {});
    },
    setShopClose() {
      this.setShop = false;
    },
    //添加弹窗关闭
    handleCloseAdd() {
      this.addDialogVisible = false;
    },
    //详情关闭
    handleCloseDetails() {
      this.details = false;
    },
    //详情确定
    preserveDetails() {
      this.details = false;
      this.gradeList();
    },
    //前往授权
    goToAuthorization() {
      window.open(
        `http://cdp.yucrm.cn//api/tbMember/authorize?shopId=${this.detailsId}`,
        "_blank"
      );
    },
    //关联店铺保存
    preserveSure() {
      let parm = {
        cardId: this.cardIdNum,
        shopIds: this.shopIdes.join(","),
      };
      relationShop(parm)
        .then((res) => {
          if (res.code == 200) {
            this.hugItemBtn(2);
          }
        })
        .catch(() => {});
      this.shopStores = false;
    },
    //详情选择
    handleSelectionChange(row) {
      var mathData = [];
      row.forEach((item) => {
        mathData.push(item.shopId);
      });
      this.shopIdes = mathData;
    },
    //设置主店铺选择
    handleSelectionChange1(row) {
      var mathData1 = [];
      row.forEach((item) => {
        mathData1.push(item.shopId);
      });
      this.shopIdes1 = mathData1;
    },
    handleCloseUn() {
      this.shopStores = false;
    },
    gradeList() {
      this.cardIdNum = "";
      if (this.index == 1) {
        this.cardIdNum = this.pastId;
      } else if (this.index == 2) {
        this.cardIdNum = this.newData.scoresCardId;
      } else {
      }
      gradeList({
        cardId: this.cardIdNum,
      })
        .then((res) => {
          this.postData = res.data.map((v) => ({
            ...v,
            edit: false,
            inputNum: v.gradeName,
          }));
        })
        .catch(() => {});
    },
    getDetailById() {
      getDetailById({
        cardId: this.pastId,
      }).then((res) => {
        this.inputN = res.data.cardName;
      });
    },
    preSeting() {
      //修改会员卡名称
      let card = {
        cardId: this.pastId,
        cardName: this.inputN,
      };
      rename(card)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.getDetailById();
            this.inputN = "";
            // setInterval(()=>{
            //   this.modifyTrue=false;
            // },1000)
          }
          this.modifyTrue = false;
        })
        .catch((err) => {});
    },
    //开关接口调取
    openSwitch(index, category, type) {
      if (type == 0) {
        this.postData[0].isValid = 1;
        this.$message.error("第一个不能关闭");
        return;
      }
      let obj = {
        gradeId: category,
      };
      if (index.isValid) {
        obj.isValid = "1";
      } else {
        obj.isValid = "0";
      }
      setValid(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success("执行成功!");
        }
      });
    },
    UpdateDetail() {
      ruleDetail({
        cardId: this.cardIdNum,
      }).then((res) => {
        //积分规则详情接口
        if (res.code == 200) {
          let obj = { ...res.data };
          this.addRuleParm.scoresCardRuleId = obj.scoresCardRuleId;
          obj.buyerGrade = obj.buyerGrade.split(",");
          for (let i in this.addRuleParm) {
            if (obj[i]) {
              this.addRuleParm[i] = obj[i];
            }
          }
          this.effectiveTime.month = obj.invalidateDate.substring(5, 7) || "";
          this.effectiveTime.day = obj.invalidateDate.substring(8, 10) || "";
          this.addRuleParm.invalidateDate =
            obj.invalidateDate.substring(0, 4) || "";
          this.addRuleParm.excludeShops = obj.excludeShops;
          this.addRuleParm.gradeItemParamDTOList[0].value = obj.vip1 + "";
          this.addRuleParm.gradeItemParamDTOList[1].value = obj.vip2 + "";
          this.addRuleParm.gradeItemParamDTOList[2].value = obj.vip3 + "";
          this.addRuleParm.gradeItemParamDTOList[3].value = obj.vip4 + "";
          this.addRuleParm.gradeItemParamDTOList[4].value = obj.vip5 + "";
          this.addRuleParm.gradeItemParamDTOList[5].value = obj.vip6 + "";
          this.addRuleParm.scoresEffectiveRules = obj.scoresEffectiveRules;
          this.addRuleParm.invalidateDateRule = obj.invalidateDateRule;
          this.addRuleParm.isValid = obj.isValid + "";
          let urlNum = this.addRuleParm.isValid;
          if (urlNum == 1) {
            this.disableFalse = "1";
          } else {
            this.disableFalse = "";
          }
          this.addRuleParm.isFreight = obj.isFreight;
        }
      });
    },
    //选择店铺
    handleClose() {
      this.selectshop = JSON.parse(
        JSON.stringify(this.addRuleParm.excludeShops)
      );
      this.dialogVisible = false;
    },
    //解除
    open(type) {
      this.sureDialogVisible = true;
      this.shopIds1 = type;
      // this.deleteConfirm(type)
    },
    deleteConfirm() {
      shopUnbind({ cardId: this.cardIdNum, shopId: this.shopIds1 })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("解除成功");
            this.bindList();
            this.gradeList();
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
      this.sureDialogVisible = false;
    },
    tabChage() {
      this.hugItemBtn();
    },
    hugItemBtn(type) {
      console.log(type);
      let bindNum = "";
      if (this.index == 1) {
        bindNum = this.pastId;
      } else if (this.index == 2) {
        bindNum = this.newData.scoresCardId;
      } else {
      }
      if (this.topSelect == 2) {
        this.bindList();
      }
      if (this.topSelect == 3) {
        this.UpdateDetail();
        this.isEdit = true;
      }
    },
    bindList() {
      bindList({
        cardId: this.pastId,
      })
        .then((res) => {
          this.bindDta = res.data;
        })
        .catch(() => {});
    },
    //编辑
    handleEdit(type, type1, type2, type3) {
      this.postData.forEach((v) => (v.edit = false));
      type.edit = true;
      let that = this;
      this.dialogVisible = true;
      that.caId = type3;
      this.sortIndex = type2;
      that.inputMenber = "";
      that.inputMoney = "";
      that.inputNum = "";
      getById({
        gradeId: type1,
      })
        .then((res) => {
          if (res.code == 200) {
            let editData = res.data;
            type.inputNum = editData.gradeName;
            that.inputMoney = editData.upgradeMinMoney;
            that.inputNum = editData.upgradeMinCount;
            that.scoresMemberGradeId = editData.scoresMemberGradeId;
            if (editData.upgradeType == 1) {
              that.checked = true;
              that.disNum = true;
              that.inputNum = 0;
            } else {
              that.checked = false;
              that.disNum = false;
            }
            if (editData.upgradeType == 2) {
              that.checked1 = true;
              that.disMoney = true;
              that.inputMoney = 0;
            } else {
              that.checked1 = false;
              that.disMoney = false;
            }
            if (editData.upgradeType == 0) {
              that.checked = true;
              that.checked1 = true;
            }
          }
        })
        .catch(() => {});
    },
    checkMoney() {
      if (this.checked == false) {
        this.disMoney = true;
        this.inputMoney = 0;
        return;
      } else {
        this.disMoney = false;
      }
    },
    checkNum() {
      if (this.checked1 == false) {
        this.disNum = true;
        this.inputNum = 0;
        return;
      } else {
        this.disNum = false;
      }
    },
    //编辑保存
    sure(item) {
      let parm = {
        gradeName: item.inputNum,
        upgradeMinCount: this.inputNum,
        upgradeMinMoney: this.inputMoney,
        scoresMemberGradeId: this.scoresMemberGradeId,
        scoresCardId: this.caId,
      };
      if (this.checked == true && this.checked1 == true) {
        this.upgradeNum = 0;
      } else if (this.checked == true && this.checked1 == false) {
        this.upgradeNum = 1;
      } else if (this.checked1 == true && this.checked == false) {
        this.upgradeNum = 2;
      }
      if (item.inputNum == "") {
        this.$message.warning("请输入会员名称");
        this.showHideJudgment = true;
        return;
      }
      if (this.checked == true && !this.inputMoney) {
        this.$message.warning("请输入交易金额");
        this.showHideJudgment = true;
        return;
      }
      if (this.checked1 == true && !this.inputNum) {
        this.$message.warning("请输入交易次数");
        this.showHideJudgment = true;
        return;
      }
      if (this.checked == false && this.checked1 == false) {
        this.$message.warning("交易金额和交易次数必须选择一个");
        this.showHideJudgment = true;
        return;
      }
      parm.upgradeType = this.upgradeNum;
      update(parm)
        .then((res) => {
          if (res.code == 200) {
            this.gradeList();
          }
        })
        .catch(() => {});
      this.showHideJudgment = false;
      item.edit = false;
    },
    //添加关联
    addAssociations() {
      this.shopStores = true;
      unbindList({})
        .then((res) => {
          this.unbindData = res.data;
        })
        .catch(() => {});
    },
    //详情
    information(type) {
      this.detailsId = type;
      this.details = true;
    },
    //添加
    addShop() {
      pageList({
        cardId: this.cardIdNum,
      })
        .then((res) => {
          this.shopInfo = res.data;
          this.shopInfo.forEach((item, index) => {
            this.shopInfo[index]["type"] = 0;
            this.shopInfo[index]["appointGoodsType"] = "";
            this.shopInfo[index]["excludeItems"] = [];
          });
        })
        .catch(() => {});
      this.addDialogVisible = true;
      this.selectshop = [...this.addRuleParm.excludeShops];
    },
    selShop(item) {
      let ind = this.selectshop
        .map((i) => i.sellerNick)
        .indexOf(item.sellerNick);
      if (ind === -1) {
        this.selectshop.push(item);
      } else {
        this.selectshop.splice(ind, 1);
      }
    },
    //保存
    preserve() {
      this.addRuleParm.excludeShops = JSON.parse(
        JSON.stringify(this.selectshop)
      );
      this.addDialogVisible = false;
    },
    //选择商品数量
    goodsDialog(row) {
      this.selectCol = row;
      this.goodsCollection = row.excludeItems;
      this.goodsState = true;
    },
    //删除
    deleteGoods(row) {
      let ind = this.selectshop
        .map((i) => i.sellerNick)
        .indexOf(row.sellerNick);
      this.selectshop.splice(ind, 1);
      this.addRuleParm.excludeShops = JSON.parse(
        JSON.stringify(this.selectshop)
      );
    },
    //等级积分倍数
    gradetimes(val, ind) {
      if (!/^\d{0,2}(.\d)?$/.test(val.replace(" ", ""))) {
        this.addRuleParm.gradeItemParamDTOList[ind].value = "";
        this.$message.warning("积分倍数(0.1-99.9)");
        return;
      }
    },
    //有效期月份改变
    monthChange(val) {
      if (val == "02") {
        this.dayList = this.dayList2.slice(0, 28);
        if (this.effectiveTime.day > 28) {
          this.effectiveTime.day = "01";
        }
      } else if (val == "04" || val == "06" || val == "09" || val == "11") {
        this.dayList = this.dayList2.slice(0, 30);
        if (this.effectiveTime.day > 30) {
          this.effectiveTime.day = "01";
        }
      } else {
        this.dayList = this.dayList2;
      }
    },
    dayChange(val) {},
    //权益设置保存
    saveUp() {
      let obj = { ...this.addRuleParm };
      if (!obj.baseScores) {
        this.$message.warning("请输入基础积分");
        return;
      }
      if (
        this.addRuleParm.gradeItemParamDTOList.filter(
          (item) => item.value === ""
        ).length > 0
      ) {
        this.$message.warning("请填写完整积分倍数");
        return;
      }
      if (
        this.addRuleParm.invalidateDateRule === 1 &&
        (!this.effectiveTime.month || !this.effectiveTime.day)
      ) {
        this.$message.warning("请选择有效期");
        return;
      }
      if (this.addRuleParm.isValid === "1") {
        if (this.addRuleParm.buyerGrade.length === 0) {
          this.$message.warning("至少选择一个参与等级");
          return;
        }
        if (this.addRuleParm.buyerDay === "") {
          this.$message.warning("请设置会员日");
          return;
        }
        if (this.addRuleParm.scoresMultiple === "") {
          this.$message.warning("请设置会员奖励");
          return;
        }
      }
      for (var i = 0; i < obj.gradeItemParamDTOList.length; i++) {
        var get1 = obj.gradeItemParamDTOList[0].value;
        var get2 = obj.gradeItemParamDTOList[1].value;
        var get3 = obj.gradeItemParamDTOList[2].value;
        var get4 = obj.gradeItemParamDTOList[3].value;
        var get5 = obj.gradeItemParamDTOList[4].value;
        var get6 = obj.gradeItemParamDTOList[5].value;
      }
      obj.vip1 = get1;
      obj.vip2 = get2;
      obj.vip3 = get3;
      obj.vip4 = get4;
      obj.vip5 = get5;
      obj.vip6 = get6;
      obj.invalidateDate =
        obj.invalidateDate +
        "-" +
        this.effectiveTime.month +
        "-" +
        this.effectiveTime.day;
      delete obj.gradeItemParamDTOList;
      obj.buyerGrade = obj.buyerGrade.join(",");
      ruleUpdate(obj).then((res) => {
        //修改积分规则接口
        if (res.code == 200) {
          this.$message.success("添加成功");
          this.isEdit = true;
          this.UpdateDetail();
        }
      });
    },
    updateTable() {
      this.showtable = false;
      this.$nextTick(() => {
        this.showtable = true;
      });
    },
    preserve1() {
      this.addRuleParm.excludeShops = JSON.parse(
        JSON.stringify(this.selectshop)
      );
      this.addDialogVisible = false;
    },
    dataBtn(data, type) {
      if (type === false) {
        this.goodsState = false;
      } else {
        this.addRuleParm.excludeShops[
          this.addRuleParm.excludeShops
            .map((i) => i.sellerNick)
            .indexOf(type.sellerNick)
        ].excludeItems = [...data];
        this.addRuleParm.excludeShops[
          this.addRuleParm.excludeShops
            .map((i) => i.sellerNick)
            .indexOf(type.sellerNick)
        ].appointGoodsType = type.searchType;
        this.goodsState = false;
      }
    },
    //返回列表
    goNumList() {
      this.$emit("transformAnalysis");
    },
  },
};
</script>
<style>
#app .el-main {
  overflow: hidden;
}
</style>
<style scoped lang="scss">
/deep/.relation-box .el-table__body-wrapper {
  max-height: 300px;
  overflow-y: auto;
}
/deep/.setting-table .el-table__empty-text {
  width: auto;
}
/deep/.el-switch.is-checked .el-switch__core {
  border-color: #7489b5;
  background-color: #7489b5;
}
.exprot-btntext {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: #333333;
  img {
    margin-right: 20px;
  }
}
.lineHug {
  height: 1px;
  background: #f3f3f3;
  opacity: 1;
  border-radius: 1px;
  margin-top: -20px;
}

.buttonColor {
  // width: 88px;
  height: 32px;
  background: #fff;
  border: 1px solid #1f4287;
  opacity: 1;
  border-radius: 6px;
  font-weight: 400;
  line-height: 12px;
  color: #1f4287 !important;
  &:hover {
    background: #1f4287;
    border: 1px solid #1f4287;
    color: #fff !important;
  }
}
.shopItem {
  // border: 1px solid #b2b2b2;
  padding: 4px 16px;
  width: 130px;
  border-radius: 6px;
  cursor: pointer;
  color: #1f4287;
  background: #ecf0f8;
  position: relative;
  & {
    margin-right: 4px;
    margin-bottom: 4px;
    display: inline-block;
  }
  &.active {
    border: 1px solid #1f4287;
  }
  .right-gou {
    position: absolute;
    bottom: 0px;
    right: 0;
  }
}

.lineLengthTwo {
  top: 53px;
  width: 100%;
  height: 1px;
  border-radius: 1px;
  position: relative;
  background: rgba(243, 243, 243, 1);
  opacity: 1;
}

.accountset1 {
  box-sizing: border-box;
  padding: 20px 30px 40px 30px;
  background: rgba(255, 255, 255, 1);
  // border: 1px solid rgba(230, 230, 230, 1);
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
  border-radius: 6px;

  .hugStyle {
    overflow: hidden;
    color: #333;
    font-size: 14px;
    margin-bottom: 20px;
    cursor: pointer;

    .underlinedFor {
      height: 2px;
      width: 40px;
      margin-left: 8px;
      text-align: center;
      margin-top: 8px;
      opacity: 1;
      cursor: pointer;

      border-radius: 2px;
    }
  }

  .display-frame {
    display: inline-block;
    width: 960px;
    height: 42px;
    opacity: 1;
    margin-bottom: 0px;
    margin-top: 16px;
    line-height: 42px;
    background: rgba(249, 250, 251, 0.6);
    border: 1px solid #eeeeee;
    border-radius: 6px;
    padding: 10px;
    padding: 18px 39px 18px 32px;

    @media screen and (max-width: 1280px) {
      width: 850px;
    }

    @media screen and (min-width: 1280px) {
      width: 850px;
    }

    @media screen and (min-width: 1366px) {
      width: 960px;
    }

    .levelSettingOne {
      position: relative;
      .spanbox {
        width: 40px;
        height: 40px;
        text-align: center;

        display: inline-block;
        background: #1f4287;
        border-radius: 50%;
        // opacity: 0.1;
        background: rgba(31, 66, 135, 0.1);
      }
      .upgradeLevelSettingsOne {
        position: absolute;
        top: -10px;
        margin-left: 76px;
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        opacity: 1;
      }

      .upgradeLevelSettingsTwo {
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        opacity: 1;
        position: absolute;
        top: 10px;
        left: 34px;
      }

      .upgradeLevelSettingsThree {
        position: absolute;
        //  top:10px;
        right: 80px;
        top: 0px;
      }
    }

    .frameTitle {
      line-height: 40px;
      height: 40px;
      background-color: #ffffff;
      background: rgba(243, 244, 247, 1);
      padding-left: 5px;
      overflow: hidden;

      .member {
        margin-left: 5px;
        margin-right: 5px;
        font-weight: 600;
        font-size: 16px;
      }

      .vipClass {
        width: 34px;
        height: 22px;
        font-size: 16px;
        font-weight: 500;
        line-height: 21px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
        margin-left: 20px;
        margin-right: 22px;
      }
    }

    .conditionSetting {
      padding: 13px 20px 20px 20px;
      .upSetting {
        width: 98px;
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        color: #333333;
        opacity: 1;
        margin-bottom: 6px;
      }
    }
  }

  .display-frame:nth-child(1) {
    margin-top: 24px;
  }

  //折叠
  .foldStyle {
    display: inline-block;
    width: 960px;
    height: 108px;
    border: 1px solid #eeeeee;
    padding: 10px;
    margin-left: -33px;
    padding: 25px 39px 0px 32px;
    border-top: 0px;
    opacity: 1;
    border-radius: 6px;
    overflow: hidden;
    color: #666666;
    @media screen and (max-width: 1280px) {
      width: 850px;
    }

    @media screen and (min-width: 1280px) {
      width: 850px;
    }

    @media screen and (min-width: 1366px) {
      width: 960px;
    }
  }

  .saveSetting {
    text-align: center;
    margin-top: 5px;
  }
}

.searchHeight {
  margin-bottom: 20px;
  //  overflow-y:hidden;
  .backList {
    width: 200px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: rgba(153, 153, 153, 1);
    opacity: 1;
    margin-bottom: 26px;
    cursor: pointer;

    .verticalLine {
      width: 1px;
      height: 18px;
      background: #ffffff;
      opacity: 1;
      margin: 0 20px;
    }

    .membership {
      width: 72px;
      height: 25px;
      font-size: 18px;
      font-weight: bold;
      line-height: 21px;
      color: #333333;
      opacity: 1;
    }
  }

  .nameCard {
    width: 84px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: #666666;
    opacity: 1;
  }
}

.levelSetting {
  margin-bottom: 15px;

  .left-hug {
    text-align: right;
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
  }

  .border-text {
    display: inline-block;
    width: 70%;
    height: 65%;
    padding: 5px;
    border: 1px solid #e6e6e6;
    vertical-align: top;
    border-radius: 8px;

    .line1 {
      width: 100%;
      font-weight: 50;
      border: 1px solid #e6e6e6;
      margin: 10px 0px;
    }
  }
}

.table-box {
  margin-top: 20px;
}

.footerStyle {
  text-align: right;
  margin-top: 30px;
}

.titleTuleset {
  height: 32px;
  line-height: 32px;
  background: rgba(246, 246, 246, 1);
  opacity: 1;
  padding-left: 10px;
  margin-top: 20px;
  margin-bottom: 30px;
  position: relative;
  color: #666666;

  .colorTitle {
    position: absolute;
    top: 8px;
    width: 3px;
    height: 16px;
    background: #1f4287;
    opacity: 1;
  }
}

.tab-cntan {
  & > div {
    margin-bottom: 20px;
    color: #666666;
    // padding-left: 30px;
  }

  .label {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    vertical-align: top;
  }

  .left-distance {
    margin-left: 98px;
  }

  .left-distance1 {
    margin-left: 70px;
  }

  .left-distance2 {
    margin-left: 58px;
  }

  .left-distance3 {
    margin-left: 15px;
  }

  .left-distance4 {
    margin-left: 85px;
  }

  .left-distance5 {
    margin-left: 110px;
  }

  .form-item {
    display: inline-block;
    height: 32px;
    line-height: 32px;
  }

  .item-inline > div {
    display: inline-block;
    margin-bottom: 10px;

    &:nth-child(2n) {
      margin-left: 86px;
    }
  }
}
.slotClass {
  background: #f6f7fa;
  border-radius: 6px;
  width: 100%;
  height: 32px;
  padding: 7px 10px;
  padding-right: 0px;

  box-sizing: border-box;
}
.slotClassTwo {
  width: 100%;
  height: 136px;
  background: #f9f9f9;
  opacity: 1;
  border-radius: 6px;
  padding: 24px 110px;
  font-size: 13px;
  box-sizing: border-box;
  color: #333333;
  font-weight: 400;
  margin-bottom: 12px;
}
</style>
